import IconCheck from '~/vendor/cxy/icons/icons/Check';
import IconCross from '~/vendor/cxy/icons/icons/Cross';
import type { BetResult } from '~/vendor/cxy/types';
import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';
import clsx from 'clsx';

import { Badge } from '../Badge';
import type { BadgeProps } from '../Badge/Badge';

import styles from './styles/Status.module.scss';

export const statusVariants = cva(styles.status, {
  variants: {
    status: {
      WON: styles['success'],
      LOST: styles['error'],
    },
  },
  defaultVariants: {
    status: 'WON',
  },
});

export type StatusProps = Omit<VariantProps<typeof statusVariants>, 'status'>;

const Status = ({
  className,
  status,
  ...props
}: {
  className?: string;
  status: BetResult;
} & StatusProps &
  Omit<BadgeProps, 'variant' | 'size' | 'className' | 'isRound'>) => {
  if (status !== 'WON' && status !== 'LOST') return null;

  const badgeVariants = {
    WON: 'primary',
    LOST: 'error',
  } as const;

  return (
    <Badge
      aria-label={`${status.toLowerCase()}-badge`}
      className={clsx(statusVariants({ status }), className)}
      data-cxy-name="status"
      isRound
      size="l"
      variant={badgeVariants[status]}
      {...props}
    >
      {status === 'WON' ? <IconCheck /> : <IconCross />}
    </Badge>
  );
};

export { Status };
